export default class PricingService {
    saveCustomerPricing = (customer, data) => {
        return axios.post(`/customers/${customer.id}/pricing`, data);
    };

    updateCustomerPricing = (customer, data) => {
        return axios.post(`/customers/${customer.id}/pricing`, data);
    };

    saveProviderPricing = (provider, data) => {
        return axios.post(`/providers/${provider.id}/pricing`, data);
    };

    updateProviderPricing = (provider, data) => {
        return axios.post(`/providers/${provider.id}/pricing`, data);
    };
}
